import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { EditorialMarquee } from "@/components/site/Marquee";
import { IMAGES } from "@/lib/content";

const VALUES = [
  ["Clarifying", "We find the opportunities already inside your business before adding anything new."],
  ["Connecting", "We build warm, reciprocal relationships that quietly fill your calendar."],
  ["Coaching", "We turn intention into a repeatable rhythm of follow-up and referral."],
];

export default function About() {
  return (
    <div data-testid="about-page" className="pt-24">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative h-[520px] lg:h-[640px] clip-arch overflow-hidden">
            <img src="/jamie-about2.webp" alt="Jamie M Rapavy" style={{ objectPosition: "38% 60%" }} className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <p className="overline text-[#B7926A] mb-6">Meet Jamie</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#47394E] leading-[0.95] tracking-tight">
            <MaskedLines lines={["Intentional", "over loud."]} />
          </h1>
          <div className="font-body text-lg text-[#47394E]/75 leading-relaxed mt-8 space-y-5">
            <p>
              I mentor established wedding professionals who want more predictable revenue — without
              relying on paid ads or constant hustle.
            </p>
            <p>
              After years in the wedding industry, I've seen one pattern repeat: the professionals
              who grow consistently aren't always the loudest marketers. They're the most
              intentional with their relationships and follow-up.
            </p>
            <p className="text-[#47394E] font-medium">A little about my experience:</p>
            <ul className="space-y-2.5 text-base">
              {[
                "25+ years in the wedding industry",
                "Extensive wedding and event planning experience",
                "Built multiple successful wedding-related businesses",
                "18+ years building a wedding professional community",
                "Helping wedding pros strengthen revenue, relationships, positioning, and business strategy",
              ].map((c) => (
                <li key={c} className="flex gap-3"><span className="text-[#A8B39B] mt-1">✦</span> {c}</li>
              ))}
            </ul>
            <p className="font-display text-2xl italic text-[#47394E]">
              Your next five bookings may be closer than you think.
            </p>
            <p className="signature text-4xl text-[#B7926A]">Jamie</p>
          </div>
        </div>
      </section>

      <EditorialMarquee items={["Coaching", "Connecting", "Clarifying"]} />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid md:grid-cols-3 gap-px bg-[#EAE3D8]">
          {VALUES.map(([title, body], i) => (
            <Reveal key={title} delay={i * 0.1}>
              <div className="bg-white p-10 h-full">
                <span className="font-display text-5xl text-[#B7926A]/70">0{i + 1}</span>
                <h3 className="font-display text-3xl text-[#47394E] mt-6">{title}</h3>
                <p className="font-body text-[#47394E]/70 mt-4 leading-relaxed">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
